import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPainfulUrination = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 20,
	viewBox: "0 0 29 20",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		d: "M1 1L13.5556 4.1389C15.7837 4.69593 17.7522 6.00296 19.1302 7.84033L27.5 19",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeDasharray: "2 5"
	})
});
export default SvgPainfulUrination;
